import actions from './actions'
import mutations from './mutations'
import queries from './queries'
import notifications from './notifications'
import tasks from './tasks'

const state = {
  statusForgotPassword: void 0,
  statusResetPassword: void 0
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  modules: {
    queries,
    notifications,
    tasks
  }
}
